import { Checkbox } from '@components-deprecated'

import { Spacing } from '@billy/design-system'
import without from 'lodash/without'
import React from 'react'

import { reactClass } from '../../../utils'
import { BankLineProvider } from '../enums/bankLineProvider'
import { ExtendedBankLineMatch, ReceiptState } from '../types'
import { calcDifference } from '../utils'
import { DroppableBankLines } from './DroppableBankLines'
import { DroppableMatchedTransactions } from './DroppableMatchedTransactions'
import { MatchListRowContext } from './MatchList'
import { MatchListRowActionOverlay as ActionOverlay } from './MatchListRowActionOverlay'
import * as Styled from './styles'

type MatchListRowProps = {
  context: MatchListRowContext
  match: ExtendedBankLineMatch
}

export const MatchListRow = ({
  match: { bankLines, id, isApproved, matchedBillyTransactions },
  context: { bulkSelectionMode, isDeleteMode, onChangeSelectedIds, selectedIds },
}: MatchListRowProps) => {
  const receiptState = bankLines?.[0]?.receiptState // I took only first `bankLine` because all bank lines get same `receiptState`
  const hasProtectedBankLine = bankLines?.some(({ provider }) => provider === BankLineProvider.BankTransactionService)
  const difference = calcDifference({ bankLines, matchedBillyTransactions })
  const createUpdateSelectionFunction = (id: string) => {
    return () => {
      onChangeSelectedIds(selectedIds.includes(id) ? without(selectedIds, id) : selectedIds.concat([id]))
    }
  }
  const isRowDisabled =
    (receiptState && receiptState === ReceiptState.MissingReceipt && !isDeleteMode) ||
    (isDeleteMode && hasProtectedBankLine && !selectedIds.includes(id))

  return (
    <Styled.MatchListRowWrapper className={reactClass('match-list-row')} id={id} isApproved={isApproved}>
      <ActionOverlay className={reactClass('remove-from-match')} forceEnabled={bulkSelectionMode}>
        <Checkbox
          margin={`${Spacing.S8} ${Spacing.S16} ${Spacing.S8} ${Spacing.S8}`}
          disabled={!!isRowDisabled}
          checked={selectedIds.includes(id)}
          onChange={createUpdateSelectionFunction(id)}
        />
      </ActionOverlay>
      <DroppableBankLines collection={bankLines} id={`bankline:${id}`} isApproved={isApproved} type="bankline" />
      <DroppableMatchedTransactions
        collection={matchedBillyTransactions}
        isApproved={isApproved}
        bankLines={bankLines}
        id={`billytransaction:${id}`}
        type="billytransaction"
        difference={difference}
      />
    </Styled.MatchListRowWrapper>
  )
}
